export default {
    namespaced: true,

    state: {
        Items: [],
        CartItemsTotalPrice: null
    },

    getters: {
        getCardItemsTotalPrice(state) {
            if (!state.Items)
                return 0;

            let accumulator = 0;
            state.Items.forEach(item => accumulator += (item.UnitPrice * item.Quantity));

            return accumulator;
        },

        /**
         * Retorna o cep de origem
         */
        getSourceZipCode(state) {
            const data = state.Items.map((item, index) => {
                if (state.Items.indexOf(item) === index)
                    return item.ZipCode;
            });

            return data.filter((item, index) => {
                return data.indexOf(item) === index;
            })[0];
        },

        /**
         * Retorna o peso total dos itens no carrinho
         */
        getTotalWeight(state) {
            let accumulator = 0;
            state.Items.forEach(item => accumulator += item.Weight);

            return accumulator;
        },
    },

    mutations: {
        /**
         * Mapeia o response da api para o módulo
         */
        setFromRequest(state, data) {
            state.Items = data.ShoppingCartItens;
        }
    }
};
